import React from 'react';
import { Storage } from 'react-jhipster';

export default class Logout extends React.Component{
    componentWillMount(){
        Storage.session.remove('jhi-authenticationToken');
    }
    render(){
        return(
            <div></div>
        );
    }
}